import { useContext } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import { FaLinkedin } from 'react-icons/fa';
import './Footer.scss';

function Footer() {
    let { languageIndex } = useContext(LanguageContext);
    let address;

    if(!languageIndex){
        address = <p>Rua Plácido Prevedello 77 – Curitiba <br />  PR – CEP: 82200-420</p>;
    } else {
        address = <p>77 Placido Prevedello St – Curitiba - Paraná State <br /> ZIP 82200-420 Brazil</p>;
    }


    return (
        <footer className='footer'>
            <div className='infos'>
                <h2>{ !languageIndex ? 'Endereço' : 'Address' }</h2>
                <p>{ address }</p>

                <h2>{ !languageIndex ? 'Contatos' : 'Contact' }</h2>
                <p><strong>Email:</strong> oilflex@oilflex.com.br</p>
                <p ><strong>{!languageIndex ? 'Telefones' : 'Phone numbers'}:</strong></p>
                <p className='phones'>{!languageIndex ? '(41)' : ' +55 041'} 99113-3388</p>
                <p className='phones'>{!languageIndex ? '(41)' : ' +55 041'} 99288-0050</p>
            </div>
            <div className='social-media'>
                <h2>{ !languageIndex ? 'Redes Sociais' : 'Social Media' }</h2>
                <a href="https://www.linkedin.com/company/oilflex-consultoria-projetos/" target='_blank' rel='noreferrer'>
                    <FaLinkedin className='icon'/>
                </a>
            </div>
            <p className='rights'>Copyright ©2025 Oilflex - { !languageIndex ? 'Desenvolvido por' : 'Developed by'} Gabriel Castro - gabrielcastro.developer@gmail.com</p>
        </footer>
    )
}

export default Footer;
